import {ResourcesUnitModel} from './ResourcesUnitModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {RegionModel} from './RegionModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';
import {DesignServicesModel} from './DesignServicesModel';
import {UnitsModel} from './UnitsModel';
import {SimulationsModel} from './SimulationsModel';

export class ServiceChangesModel {
  id: number;
  numAnnoMese: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  shareName: string;
  applicationCod: string;
  delta: number;
  contractType: ContractTypeModel;
  designServices: DesignServicesModel;
  units: UnitsModel;
  provider: ProviderModel;
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
  simulationRef: SimulationsModel;
  servicesRef: ServiceChangesModel;


  constructor(id?: number, numAnnoMese?: number, region?: RegionModel,
              localCustomer?: LocalCustomerModel, resourceUnit?: ResourcesUnitModel,
              shareName?: string, applicationCod?: string, delta?: number,
              contractType?: ContractTypeModel, units?: UnitsModel,
              provider?: ProviderModel, sl1?: DesignServicesModel,
              numAnnoMeseFrom?: number, numAnnoMeseTo?: number,
              simulationRef?: SimulationsModel, servicesRef?: ServiceChangesModel) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.shareName = shareName;
    this.applicationCod = applicationCod;
    this.delta = delta;
    this.contractType = contractType;
    this.designServices = sl1;
    this.units = units;
    this.provider = provider;
    this.numAnnoMeseFrom = numAnnoMeseFrom;
    this.numAnnoMeseTo = numAnnoMeseTo;
    this.simulationRef = simulationRef;
    this.servicesRef = servicesRef;
  }
}
